import PlayMetrics from '../models/PlayMetricsModel';
import { stitchDefaults } from './defaults';

export default {
    ...stitchDefaults,
    pathTemplate: 'bdfed/playMetrics/{gamePk}?keyMoments={keyMoments}&scoringPlays={scoringPlays}&homeRuns={homeRuns}&strikeouts={strikeouts}&hardHits={hardHits}&highLeverage={highLeverage}&leadChange={leadChange}&winProb={winProb}',
    expires: 9,
    model: PlayMetrics
};
